import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCentralAfricanRepublic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_719)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.541 6.26086C20.9903 3.41888 18.3239 1.27345 15.1305 0.412735L14.6088 6.26086H22.541Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.45911 6.26086H9.3913L8.86958 0.412735C5.67612 1.27345 3.00978 3.41892 1.45911 6.26086Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6087 12V17.7391H22.5409C23.4711 16.0342 24 14.0789 24 12H14.6087Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.39131 12H0C0 14.0789 0.528891 16.0342 1.45908 17.7391H9.39127V12H9.39131Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.45911 17.7391C3.00978 20.5811 5.67612 22.7265 8.86958 23.5873L9.3913 18.4728L1.45911 17.7391Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1305 23.5873C18.3239 22.7265 20.9903 20.5811 22.541 17.7391L14.6088 18.4727L15.1305 23.5873Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6087 18.4727L22.5409 17.7391H14.6087V18.4727Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.39134 17.7391H1.45911L9.39134 18.4727V17.7391Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C10.9169 0 9.86772 0.144375 8.86957 0.413391V23.5867C9.86772 23.8556 10.9169 24 12 24C13.0832 24 14.1323 23.8556 15.1305 23.5866V0.413391C14.1323 0.144375 13.0832 0 12 0V0Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.45457 2.60869L6.77828 3.60511H7.82608L6.97849 4.22095L7.30225 5.21738L6.45457 4.60158L5.60693 5.21738L5.93078 4.22095L5.08319 3.60511H6.13089L6.45457 2.60869Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_719",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgCentralAfricanRepublic;
